import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-down",
  "use": "icon-down-usage",
  "viewBox": "0 0 8 5",
  "content": "<symbol viewBox=\"0 0 8 5\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-down\">\r\n<path d=\"M7.35012 0.812348C7.61203 0.484966 7.37894 5.42947e-08 6.95969 9.0947e-08L1.04031 6.08435e-07C0.621059 6.45088e-07 0.387973 0.484967 0.649878 0.812348L3.60957 4.51196C3.80973 4.76216 4.19027 4.76216 4.39043 4.51196L7.35012 0.812348Z\" fill=\"white\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol